import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { initializeOcurrencesAppealed } from '../../../redux/actions/f5-actions/ocurrences-list-init';
import { Grid } from '@material-ui/core';
import GridContainer from '../../../@jumbo/components/GridContainer';

import SimpleDataCard from '../../ocurrences/SharedComponents/SimpleDataCard';
import OcurrencesDataRender from '../../ocurrences/SharedComponents/OcurrencesDataRender';

import SyncProblemIcon from '@material-ui/icons/SyncProblem';

const AppealedOcurrences = () => {
  const [currentList, setCurrentList] = useState('appealed');
  const appealedData = useSelector(({ ocurrences_data }) => ocurrences_data.appealed.caixa);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initializeOcurrencesAppealed());
  }, [dispatch]);

  const ocurrencesData = {
    appealed: {
      icon: <SyncProblemIcon fontSize="large" />,
      label: 'Ocorrências em Recurso',
      colors: ['#d9216d', '#e63980'],
      data: appealedData,
    },
  };

  return (
    <GridContainer>
      <Grid item xs={12} sm={6} md={3}>
        <SimpleDataCard
          label={ocurrencesData.appealed.label}
          icon={ocurrencesData.appealed.icon}
          colors={ocurrencesData.appealed.colors}
          value={ocurrencesData.appealed.data ? ocurrencesData.appealed.data.length : 0}
          setList={() => setCurrentList('appealed')}
        />
      </Grid>
      <Grid item xs={12}>
        <OcurrencesDataRender
          bgcolor={ocurrencesData[currentList].colors[0]}
          data={ocurrencesData[currentList].data}
          label={ocurrencesData[currentList].label}
          icon={ocurrencesData[currentList].icon}
        />
      </Grid>
    </GridContainer>
  );
};

export default AppealedOcurrences;
